import { Directive, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[collapsible]'
})
export class CollapsibleDirective implements OnInit {

  @Input('collapsibleSection') collapsibleSection: any;
  @Input('collapsibleTitle') collapsibleTitle: any;
  @Input('isExpandOnDesktop') isExpandOnDesktop: boolean = false;
  @Input('isCollapsed') isCollapsed: boolean = false;
  @Input('isNotAnimated') isNotAnimated: boolean = false;

  private collapseSection(element: any) {
    this.isCollapsed = true;

    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // temporarily disable all css transitions
    var elementTransition = element.style.transition;
    element.style.transition = '';

    if (!this.isNotAnimated) {
      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we 
      // aren't transitioning out of 'auto'
      requestAnimationFrame(function () {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
          element.style.height = 0 + 'px';
        });
      });
    } else {
      element.style.height = 0 + 'px';
    }

    // mark the section as "currently collapsed"
    element.setAttribute('data-collapsed', 'true');

    if (this.collapsibleTitle && this.collapsibleTitle.classList.contains('open')) {
      this.collapsibleTitle.classList.remove('open');
    }
  }


    collapseItemSection(element: any) {
        this.isCollapsed = true;

        // get the height of the element's inner content, regardless of its actual size
        var sectionHeight = element.scrollHeight;

        // temporarily disable all css transitions
        var elementTransition = element.style.transition;
        element.style.transition = '';

        if (!this.isNotAnimated) {
            // on the next frame (as soon as the previous style change has taken effect),
            // explicitly set the element's height to its current pixel height, so we 
            // aren't transitioning out of 'auto'
            requestAnimationFrame(function () {
                element.style.height = sectionHeight + 'px';
                element.style.transition = elementTransition;

                // on the next frame (as soon as the previous style change has taken effect),
                // have the element transition to height: 0
                requestAnimationFrame(function () {
                    element.style.height = 0 + 'px';
                });
            });
        } else {
            element.style.height = 0 + 'px';
        }

        // mark the section as "currently collapsed"
        element.setAttribute('data-collapsed', 'true');

        if (this.collapsibleTitle && this.collapsibleTitle.classList.contains('open')) {
            this.collapsibleTitle.classList.remove('open');
        }
    }

  private expandSection(element: any) {
    this.isCollapsed = false;

    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + 'px';

    if (!this.isNotAnimated) {
      // when the next css transition finishes (which should be the one we just triggered)
      var eventFunction = function (e: any) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', eventFunction);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = null;
      };

      element.addEventListener('transitionend', eventFunction);
    } else {
      element.style.height = null;
    }

    // mark the section as "currently not collapsed"
    element.setAttribute('data-collapsed', 'false');

    if (this.collapsibleTitle && !this.collapsibleTitle.classList.contains('open')) {
      this.collapsibleTitle.classList.add('open');
    }
  }

  ngOnInit(): any {
    if (this.isCollapsed)
      this.collapseSection(this.collapsibleSection);
  }

  @HostListener('click', ['$event']) onClick($event: any) {
    if (this.isCollapsed) {
      this.expandSection(this.collapsibleSection);
    } else {
      this.collapseSection(this.collapsibleSection);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (!this.isExpandOnDesktop) return;
    if (this.isCollapsed && event.target.innerWidth >= 768) {
      this.expandSection(this.collapsibleSection);
      }
      if (!this.isCollapsed && event.target.innerWidth >= 768) {
          this.collapseSection(this.collapsibleSection);
      }
  }
}
